export const MAX_WORD_LENGTH = 500 //TODO was solution.length, to be adjusted
export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 2000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
